import { useState } from "react";
import { Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import DashboardShell, { Panel } from "@/components/DashboardShell";
import { CATEGORIES } from "@/lib/categories";
import { User, Search, Heart, Phone, Mail, MapPin, CalendarHeart } from "lucide-react";

export default function CustomerAccount() {
  const { user } = useAuth();
  const [tab, setTab] = useState("home");
  const items = [
    { key: "home", label: "My account", Icon: User },
    { key: "explore", label: "Start planning", Icon: Search },
  ];
  return (
    <DashboardShell title={`Namaste, ${user?.name || "there"}`} subtitle="Your details and quick ways to plan your event." items={items} active={tab} onSelect={setTab}>
      {tab === "home" && (
        <div className="grid lg:grid-cols-[1fr_1.3fr] gap-6">
          <Panel title="Your details">
            <dl className="space-y-3 text-[15px]">
              {[[Mail, "Email", user?.email], [Phone, "Phone", user?.phone], [MapPin, "City", user?.city], [CalendarHeart, "Planning", user?.target]].map(([I, k, v]) => (
                <div key={k} className="flex items-center gap-3"><I className="w-4 h-4 text-[color:var(--gold)]"/><dt className="w-24 text-neutral-500">{k}</dt><dd className="font-semibold text-[color:var(--ink)] capitalize-first">{v || "—"}</dd></div>
              ))}
            </dl>
          </Panel>
          <Panel title="What do you need?">
            <div className="grid grid-cols-2 sm:grid-cols-4 gap-2">
              {CATEGORIES.map((c) => (
                <Link key={c.key} to={`/properties?category=${c.key}${user?.city ? `&city=${encodeURIComponent(user.city)}` : ""}`} className="rounded-2xl bg-[color:var(--cream)] border border-[color:var(--line)] p-3 hover:border-[color:var(--maroon)] press">
                  <c.Icon className="w-5 h-5 text-[color:var(--maroon)]"/>
                  <div className="text-[14px] font-semibold mt-2 leading-tight">{c.plural}</div>
                </Link>
              ))}
            </div>
            <div className="flex flex-wrap gap-2 mt-5">
              <Link to="/properties" className="btn-wine">Browse listings</Link>
              <Link to="/contact" className="btn-ghost"><Heart className="w-4 h-4"/> Get a free shortlist</Link>
            </div>
          </Panel>
        </div>
      )}
      {tab === "explore" && (
        <Panel title="Plan in three steps">
          <ol className="space-y-5">
            {[["Pick your city and date", "Search shows places and people who are free on your date.", "/properties"], ["Shortlist and compare", "Photos, videos, menus and packages side by side.", "/highlighted"], ["Call the owner directly", "Every listing shows the owner's number — no commission.", "/properties"]].map(([t, d, to], i) => (
              <li key={t} className="flex gap-4">
                <span className="w-10 h-10 shrink-0 rounded-full bg-[color:var(--maroon)] text-[color:var(--gold-2)] flex items-center justify-center font-num text-lg">{i + 1}</span>
                <div><Link to={to} className="font-semibold text-[17px] text-[color:var(--ink)] hover:underline">{t}</Link><p className="text-[15px] text-[color:var(--ink-2)]">{d}</p></div>
              </li>
            ))}
          </ol>
        </Panel>
      )}
    </DashboardShell>
  );
}
